<template>
    <div class="workordrAssign">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>办理结果不通过，重新分派至当前承办单位
        </div>
        <div class="workordr_content">
            <el-form label-width="120px"
                     :model="ruleForm"
                     :rules="rules"
                     label-position="left"
                     ref="ruleFormRef"
            >
                <div class="workordr_main">
                    <div>
                        <el-form-item label="发起原因" prop="czCzjgwb">
                            <el-input maxlength="2000" :autosize="{ minRows: 5}"  v-model="ruleForm.czCzjgwb" show-word-limit type="textarea"/>
                        </el-form-item>
                        <!--<div class="workordr_footer">-->
                        <!--<div class="workordr_footer_zpcbdw">-->
                        <!--转派承办单位-->
                        <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance} from 'vue'
    import {ElMessageBox,ElLoading} from 'element-plus'
    import {useStore} from 'vuex';

    export default {
        name: "Workorder_SQTH",
        props: ["gdId","thqx"],
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": 'CXFQ',
                "gdId": props.gdId,
                czCzjgwb:""
            });
            const rules = reactive({
            });
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent");
                                        store.state.addNewWorkorderSuccess=true;
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };

            //取消事件
            const cancleClick=()=>{
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })

            }

            onMounted(() => {
            });
            return {
                ruleForm,
                rules,
                ruleFormRef,
                submitForm,
                cancleClick,
            }
        }
    }
</script>

<style scoped lang="less">
    .workordr_main.cxfq{
        padding-bottom:0;
        font-weight: bold;
        height: 30px;
        line-height: 30px;
    }
</style>
